import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import useSWR from "swr";
import RouteTripMap from "../../../Components/Create/SelectPointMap";
import { getTripMetaData } from "../../../lib/PB/Trips";
import { TripPoint } from "../../../Types/Trip";

export const Route = createFileRoute("/Trips/$TripId/Track")({
  component: TrackTrip,
});

export default function TrackTrip() {
  const { TripId } = Route.useParams();

  const { data } = useSWR("/api/trips/track", () =>
    getTripMetaData(TripId, true)
  );

  // useEffect(() => {
  //   const f = subTottrip("xi5fj1fxduo36v7");
  //   console.log("should sub");
  //   return () => {
  //     console.log("should unsub");
  //     f.then((un) => un());
  //   };
  // }, []);

  // const sendLocation = (l) => {
  //   console.log("location", l);
  // };

  // useEffect(() => {
  //   let watchNumber = -1;
  //   const interKey = setInterval(() => {
  //     if (navigator.geolocation) {
  //       navigator.permissions
  //         .query({ name: "geolocation" })
  //         .then(function (result) {
  //           // console.log(result);
  //           if (result.state === "granted") {
  //             navigator.geolocation.getCurrentPosition((p) => {
  //               Notification.requestPermission().then((w) => {
  //                 if (w === "granted") {
  //                   new Notification(
  //                     `lat: ${p.coords.latitude}, lon: ${p.coords.longitude}`
  //                   );
  //                 }
  //               });
  //             });
  //           } else if (result.state === "prompt") {
  //             //If prompt then the user will be asked to give permission

  //           } else if (result.state === "denied") {
  //             //If denied then you have to show instructions to enable location
  //           }
  //         });
  //     } else {
  //       console.log("Geolocation is not supported by this browser.");
  //     }
  //   }, 10000);
  //   return () => {
  //     console.log("interKey", interKey);
  //     console.log("watchNumber", watchNumber);
  //     clearInterval(interKey);
  //     if (watchNumber > -1) navigator.geolocation.clearWatch(watchNumber);
  //   };
  // }, []);

  const [orientation, setOrientation] = useState({
    absolute: false,
    alpha: -1,
    beta: -1,
    gamma: -1,
  });
  useEffect(() => {
    function handleOrientation(e: DeviceOrientationEvent) {
      const absolute = e.absolute;
      const alpha = e.alpha;
      const beta = e.beta;
      const gamma = e.gamma;
      console.log(absolute, alpha, beta, gamma);
      setOrientation({ absolute, alpha, beta, gamma });
    }

    window.addEventListener("deviceorientation", handleOrientation, true);

    return () => {
      window.removeEventListener("deviceorientation", handleOrientation, true);
    };
  }, []);

  useEffect(() => {
    let watchNumber = -1;
    if (navigator.geolocation) {
      console.log("ha");
      navigator.permissions
        .query({ name: "geolocation" })
        .then(function (result) {
          if (result.state === "granted") {
            watchNumber = navigator.geolocation.watchPosition(
              (p) => {
                // p.coords.heading
                Notification.requestPermission().then((w) => {
                  console.log("waht?");
                  if (w === "granted") {
                    new Notification(
                      `lat: ${p.coords.latitude}, lon: ${p.coords.longitude}`
                    );
                  }
                });
              },
              null,
              { enableHighAccuracy: true, maximumAge: 5000, timeout: 5000 }
            );
          } else if (result.state === "prompt") {
            //If prompt then the user will be asked to give permission
            watchNumber = navigator.geolocation.watchPosition(
              (p) => {
                Notification.requestPermission().then((w) => {
                  if (w === "granted") {
                    console.log("waht?");
                    new Notification(
                      `lat: ${p.coords.latitude}, lon: ${p.coords.longitude}`
                    );
                  }
                });
              },
              null,
              { enableHighAccuracy: true, maximumAge: 5000, timeout: 5000 }
            );
          } else if (result.state === "denied") {
            //If denied then you have to show instructions to enable location
          }
        });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
    return () => {
      console.log("watchNumber", watchNumber);
      if (watchNumber > -1) navigator.geolocation.clearWatch(watchNumber);
    };
  }, []);

  useEffect(() => {
    Notification.requestPermission().then((request) => {
      if (request === "granted") {
        new Notification("tmam");
        navigator.serviceWorker.getRegistrations().then((regs) => {
          for (const register of regs) {
            const StringfiedtokenObj = localStorage.getItem("pocketbase_auth");
            const token = JSON.parse(StringfiedtokenObj)?.["token"];
            register.active.postMessage({ authToken: token });
          }
        });
      }
    });

    return () => {
      console.log("AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA");
    };
  }, []);

  const pointsArray =
    data?.expand?.points.map((p) => {
      return {
        address: p.adress,
        index: p.index,
        lat: p.lat,
        lon: p.lon,
      } as TripPoint;
    }) ?? [];

  return (
    <div>
      <div>
        <div>orientation abs: {orientation.absolute}</div>
        <div>orientation alpha: {orientation.alpha}</div>
        <div>orientation beta: {orientation.beta}</div>
        <div>orientation gamma: {orientation.gamma}</div>
      </div>
      TrackTrip
      <RouteTripMap originalCoordsArray={pointsArray} />
    </div>
  );
}
